import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
import uploadfile from '@/components/mapv2/uploadfile';
import { BMapLoader } from '@/utils/bdMap.js';
import { setImgsize, loadScript, escapeHTML } from '@/utils/utils';
import { mapState, mapGetters, mapMutations } from 'vuex';
import pointtext from '@/components/mapv2/pointtext';
import pointicon from '@/components/mapv2/pointicon';
import cdata from '@/view/map/hdmconfigv2/common.js';
let _ = require('lodash');
export default {
  name: 'pointdatav2',
  components: {
    uploadfile,
    pointtext,
    pointicon
  },
  meta: {
    title: ''
  },
  props: {
    form: {
      type: Object,
      default: {}
    },
    formlabel: {
      type: Object,
      default: {}
    },
    formoption: {
      type: Object,
      default: {}
    },
    formfield: {
      type: Object,
      default: {}
    },
    mapform: {
      type: Object,
      default: {}
    },
    mapformoption: {
      type: Object,
      default: {}
    },
    isadd: {
      type: Boolean,
      default: true
    },
    typelist: {
      type: Array,
      default: true
    }
  },
  data() {
    return {
      leveloptions: [],
      timer: null,
      bdmap: {},
      // 选择地址回填对象
      bdDialog: false,
      // 百度地图弹框
      bdinput: '',
      BDMap: null,
      // 百度地图对象
      point: '',
      // 当前选择点
      bdpointformat: {},
      pointShow: false,
      typeList: [],
      typeprops: {
        multiple: true
      },
      key1: 0,
      routeFlag: false,
      activeNames: ['1', '2', '3', '4'],
      moreShow: false,
      defaultseniorstyle: {},
      seniorstyle: {},
      saveseniorstyle: {},
      pointStyleIndex: 0,
      form4: [],
      isFollowglobal: true,
      //是否跟随全局样式设置
      pointOptions: [],
      // 点位样式选项
      pointStyleIndex: 0,
      // 点位样式索引
      pointItem: {} // 点位当前样式
    };
  },
  created() {
    this.pointOptions = cdata.pointStyle;
    loadScript('https://noteyd.chaoxing.com/res/plugin/ueditor4thirdparty/multieditor.js').then(res => {
      MultiEditor.init('edit', null, {
        isGetVideoDataFromCenter: true,
        largePreview: true,
        //是否是大窗口预览
        attachMode: 'preview' // preview（预览）、text（文本）、card（卡片） 三种
      });
      MultiEditor.initEditor({
        'editorid': 'editor1'
      });
    });
  },
  computed: {
    ...mapGetters(['mapv2info'])
  },
  watch: {
    isadd(val) {
      // console.log(`isadd`, val);
      if (val) this.reset();
    },
    form(val) {
      console.log(`this.pointform`, this.form);
      if (Object.keys(val).length > 0) {
        this.key1++;
        console.log(MultiEditor);
        /* MultiEditor存在 */
        this.timer = setInterval(() => {
          if (MultiEditor !== undefined) {
            clearInterval(this.timer);
            MultiEditor.destoryEditor('editor1');
            MultiEditor.init('edit', null, {
              isGetVideoDataFromCenter: true,
              largePreview: true,
              attachMode: 'preview'
            });
            if (this.form.introduce !== '') {
              MultiEditor.initEditor({
                editorid: 'editor1',
                content: this.form.introduce,
                editorheight: 300
              });
            } else {
              MultiEditor.initEditor({
                'editorid': 'editor1'
              });
            }
          }
        }, 100);
        console.log(`val.map_type`, val.map_type);
        this.form.map_type = val.map_type.length > 0 && this.isValidJSON(val.map_type) ? [...JSON.parse(val.map_type)] : '';
        // 默认导入全局图片、文字样式
        this.defaultseniorstyle = _.cloneDeep(this.form.defaultseniorset);
        // 导入单个图片、文字样式
        if (this.form.seniorset === undefined || this.form.seniorset === '') {
          this.seniorstyle = _.cloneDeep(this.form.defaultseniorset);
        } else {
          this.seniorstyle = _.cloneDeep(this.form.seniorset);
          if (this.seniorstyle.text === undefined || this.seniorstyle.text.isTrusted) {
            this.seniorstyle.text = {
              ...this.defaultseniorstyle.text
            };
          }
          if (this.seniorstyle.pic === undefined || Object.keys(this.seniorstyle.pic).length === 0) this.seniorstyle.pic = {
            ...this.defaultseniorstyle.pic
          };
          if (this.seniorstyle.icon === undefined || Object.keys(this.seniorstyle.icon).length === 0) this.seniorstyle.icon = {
            ...this.defaultseniorstyle.icon
          };
        }
        this.saveseniorstyle = _.cloneDeep(this.seniorstyle);
        this.bdpointformat = val.route.length > 0 ? val.route[0] : {};
        this.form4 = _.cloneDeep(this.form[4]);
        if (val.route.length > 0) {
          this.bdpointformat = val.route[0];
          this.bdmap.address = val.route[0].address;
        }

        // 点位兼容可选择样式
        if (this.saveseniorstyle.isFollowglobal === undefined) {
          this.saveseniorstyle.isFollowglobal = this.isFollowglobal;
        } else {
          this.isFollowglobal = this.saveseniorstyle.isFollowglobal;
        }
        if (this.saveseniorstyle.pointStyleIndex === undefined) {
          this.saveseniorstyle.pointStyleIndex = this.defaultseniorstyle.pointStyleIndex;
        } else {
          this.pointStyleIndex = this.seniorstyle.pointStyleIndex;
        }
        this.pointItem = this.pointOptions[this.pointStyleIndex];
        console.log(`this.defaultseniorstyle`, this.defaultseniorstyle);
        console.log(`this.seniorstyle`, this.seniorstyle);
        console.log(`this.saveseniorstyle`, this.saveseniorstyle);
      }
    },
    mapform: {
      handler(val) {
        // console.log(`mapform`);
        // console.log(val);
      },
      deep: true
    },
    typelist: {
      handler(val) {
        this.typelistHandle(val);
      },
      deep: true
    },
    'mapv2info.view.minZoom': {
      handler(val) {
        // console.log('mapv2info.view.minZoom');
        // console.log(val);
        this.getLevel();
      },
      deep: true
    },
    'mapv2info.view.maxZoom': {
      handler(val) {
        // console.log('mapv2info.view.maxZoom');
        // console.log(val);
        this.getLevel();
      },
      deep: true
    },
    'mapv2info.coordinate': {
      handler(val) {
        // console.log('mapv2info.coordinate');
        // console.log(val);
        this.getCoordinate();
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      // console.log(this.mapform);
      this.getLevel();
      this.typelistHandle(this.typelist);
    });
  },
  methods: {
    isValidJSON(text) {
      try {
        JSON.parse(text);
        return true;
      } catch (error) {
        return false;
      }
    },
    submitHandle() {
      var richtext = MultiEditor.getRichText('editor1');
      this.form.introduce = richtext.rtf_content;
      this.form.route = [this.bdpointformat];
      if (this.form.map_type) {
        let data = this.form.map_type.map(elem => {
          if (elem.length > 1) elem = elem.join('/');
          return elem;
        });
        this.form.map_type2 = data.join(',');
      }
      let formatform = _.cloneDeep(this.form);
      formatform.introduce = this.getFormatDom(richtext.rtf_content);
      let encodeName = ['portal_link', 'special_link', 'virtual_link', '44'];
      encodeName.forEach(elem => {
        if (formatform[elem]) formatform[elem] = encodeURIComponent(formatform[elem]);
      });

      // 添加或编辑点位时 判断全局高级样式与单个样式是否相等  不相等则单独保存
      // if (!_.isEqual(this.defaultseniorstyle, this.saveseniorstyle)) {
      formatform.seniorset = `<p element-id=\"init\" style="display: none;">${JSON.stringify(this.saveseniorstyle)}</p>`;
      // }
      formatform[4] = this.form4;
      this.moreShow = false;
      this.$refs['formdata'].validate(valid => {
        if (valid) {
          this.$emit('submit', formatform);
        }
      });
    },
    getFormatDom(htmlString) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');
      let resultStr = '';
      doc.body.children.forEach(child => {
        if (child.tagName === 'P') child.innerHTML = encodeURIComponent(escapeHTML(child.innerHTML));
        if (child.tagName === 'DIV' && child.getAttribute('class') === 'drag-image-wrap') {
          let src = child.getElementsByTagName('img')[0].getAttribute('src');
          child.getElementsByTagName('img')[0].setAttribute('src', encodeURIComponent(src));
        }
        if (child.tagName === 'DIV' && child.getAttribute('class') === 'editor-iframe') {
          let src = child.getElementsByTagName('iframe')[0].getAttribute('src');
          let prefix = 'noteyd.chaoxing.com/attachment/';
          if (!src.includes(prefix)) child.getElementsByTagName('iframe')[0].setAttribute('src', `${prefix}${src}`);
        }
        resultStr += child.outerHTML;
      });
      return resultStr;
    },
    fileListHandle(val, type) {
      if (type === '4') this.form4 = val;
      this.form[type] = val;
      console.log(`this.form`, this.form);
    },
    pointopen() {
      this.pointShow = true;
    },
    pointclose() {
      this.reset();
      this.pointShow = false;
      this.moreShow = false;
    },
    reset() {
      this.$refs['formdata'].resetFields();
    },
    // 获取静态地图上的定位点
    getCoordinate() {
      this.form.map_coordinates = this.mapv2info.coordinate;
    },
    /**
     * 选择层级处理
     */
    getLevel() {
      this.leveloptions = [];
      let min = this.mapv2info.view.minZoom;
      let max = this.mapv2info.view.maxZoom;
      let len = max - min;
      let manlen = min + len;
      if (len > 0) {
        for (let i = min; i <= manlen; i++) {
          this.leveloptions.push({
            title: i
          });
        }
      } else {
        this.leveloptions = [{
          title: min
        }];
      }
    },
    /**
     * 分类项处理
    * @param {Array} data 分类列表数据
     */
    typelistHandle(data) {
      this.typeList = [];
      if (data.length > 0) {
        data.forEach(elem => {
          let item = elem.itemformdata;
          let obj = {
            value: item.title,
            label: item.title,
            children: []
          };
          // console.log(item);
          if (item.json && item.json.length > 0) {
            let children = [...JSON.parse(item.json.replace(/(<\/?p.*?>)/gi, ''))];
            let childrenArr = [];
            children.forEach(child => {
              let cobj = {
                value: child.title,
                label: child.title
              };
              childrenArr.push(cobj);
            });
            obj.children = childrenArr;
          }
          this.typeList.push(obj);
        });
        console.log(`this.typeList`, this.typeList);
      }
    },
    /**
     * 分类值改变操作
    * @param {Array} data 数据
     */
    cascaderHandle(val) {
      console.log(val);
    },
    bdDialogHandle() {
      this.bdpointformat = {};
      this.bdDialog = true;
      this.routeFlag = true;
      this.getLocation();
    },
    getLocation() {
      this.$nextTick(() => {
        BMapLoader().then(BMap => {
          this.BDMap = new BMap.Map('bdmap', {
            enableMapClick: false
          });
          let geolocation = new BMap.Geolocation();
          geolocation.getCurrentPosition(a => {
            console.log(a);
            if (this.routeFlag) this.bdmap.address = a.address.city + a.address.district + a.address.street + a.address.street_number;
            this.bdmap.lng = a.point.lng;
            this.bdmap.lat = a.point.lat;
            this.point = new BMap.Point(a.point.lng, a.point.lat);
            this.BDMap.centerAndZoom(this.point, 15);
            this.BDMap.clearOverlays();
            let marker = new BMap.Marker(this.point);
            this.BDMap.addOverlay(marker);
            this.bdpointformat = {
              ...a.address,
              ...this.bdmap
            };
            if (!this.routeFlag) this.form.map_coordinates = `${a.point.lng.toFixed(6)},${a.point.lat.toFixed(6)}`;
          });
          this.BDMap.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
          // 添加中心点和缩放等级，如果不添加，初始化出来页面为白屏
          this.searchComplate(BMap);
          let that = this;
          this.BDMap.addEventListener('click', function (e) {
            new BMap.Geocoder().getLocation(e.latlng, function (rs) {
              console.log(`rs`, rs);
              if (that.routeFlag) that.bdmap.address = rs.address;
              let surroundingPois = rs.surroundingPois;
              if (surroundingPois.length > 0) {
                let province = rs.addressComponents.province;
                if (surroundingPois[0].address.indexOf(province) === 0) province = '';
                let headAddress = (rs.addressComponents.province === rs.addressComponents.city ? '' : rs.addressComponents.city) + rs.addressComponents.district;
                if (surroundingPois[0].address.indexOf(headAddress) === 0 || surroundingPois[0].address.indexOf(rs.addressComponents.province + headAddress) === 0) {
                  headAddress = '';
                }
                if (that.routeFlag) that.bdmap.address = province + headAddress + surroundingPois[0].address + surroundingPois[0].title;
              }
              that.bdpointformat = {
                ...rs.point,
                ...rs.addressComponents
              };
            });
            that.bdmap.lng = e.latlng.lng;
            that.bdmap.lat = e.latlng.lat;
            that.point = new BMap.Point(e.latlng.lng, e.latlng.lat);
            that.BDMap.panTo(that.point);
            that.BDMap.clearOverlays();
            let marker = new BMap.Marker(that.point);
            that.BDMap.addOverlay(marker);
            console.log(that.bdmap);
            if (!that.routeFlag) that.form.map_coordinates = `${e.latlng.lng.toFixed(6)},${e.latlng.lat.toFixed(6)}`;
          });
        });
      });
    },
    searchComplate(BMap) {
      let _this = this;
      //建立一个自动完成的对象
      let ac = new BMap.Autocomplete({
        'input': 'suggestId',
        'location': this.BDMap
      });
      let myValue;
      ac.addEventListener('onconfirm', function (e) {
        //鼠标点击下拉列表后的事件
        console.log(e);
        let _value = e.item.value;
        myValue = _value.province + _value.city + _value.district + _value.street + _value.business;
        _this.G('searchResultPanel').innerHTML = 'onconfirm<br />index = ' + e.item.index + '<br />myValue = ' + myValue;
        _this.setPlace(myValue, BMap, _value);
      });
    },
    G(id) {
      return document.getElementById(id);
    },
    setPlace(myValue, BMap, value) {
      this.BDMap.clearOverlays(); //清除地图上所有覆盖物
      let that = this;
      const myFun = () => {
        let pp = local.getResults().getPoi(0).point; //获取第一个智能搜索的结果
        that.BDMap.centerAndZoom(pp, 18);
        that.BDMap.addOverlay(new BMap.Marker(pp)); //添加标注
        if (that.routeFlag) that.bdmap.address = local.getResults().province + local.getResults().keyword;
        that.bdmap.lng = pp.lng;
        that.bdmap.lat = pp.lat;
        that.bdpointformat = {
          ...value,
          ...that.bdmap
        };
        if (!that.routeFlag) that.form.map_coordinates = `${pp.lng.toFixed(6)},${pp.lat.toFixed(6)}`;
      };
      let local = new BMap.LocalSearch(this.BDMap, {
        //智能搜索
        onSearchComplete: myFun
      });
      local.search(myValue);
    },
    searchCoordinates() {
      this.routeFlag = false;
      this.bdDialog = true;
      this.getLocation();
    },
    handleChange() {},
    /**
     * 高级设置 文字设置
    * @param {Object} val 数据
     * @date 2025-06-04
     */
    TextChange(val) {
      this.saveseniorstyle.text = val;
      // 加个限制 当高级设置打开时 改变才触发
      if (!this.moreShow) return;
      this.$emit('stylechange', {
        item: this.form,
        data: this.saveseniorstyle
      });
    },
    /**
     * 高级设置 图片设置
    * @param {Object} val 数据
     * @date 2025-06-04
     */
    picChange(val) {
      console.log(`picChange`, val);
      this.saveseniorstyle.pic = val;
      // 加个限制 当高级设置打开时 改变才触发
      if (!this.moreShow) return;
      this.$emit('stylechange', {
        item: this.form,
        data: this.saveseniorstyle
      });
    },
    /**
     * 高级设置 图标设置
    * @param {Object} val 数据
     * @date 2025-09-02
     */
    iconChange(val) {
      console.log(`iconChange`, val);
      this.saveseniorstyle.icon = val;
      // 加个限制 当高级设置打开时 改变才触发
      if (!this.moreShow) return;
      this.$emit('stylechange', {
        item: this.form,
        data: this.saveseniorstyle
      });
    },
    /**
     * 打开素材库
     * @date 2025-06-17
     */
    openSourceMaterial(type) {
      let obj = {
        type: type,
        title: '图片库'
      };
      if (this.form[4].length > 0) obj.pic = this.form[4];
      this.$emit('openSource', obj);
    },
    /**
     * 选中素材回调事件
    * @param {Object} data 数据
     * @date 2025-06-17
     */
    changeform4(data) {
      console.log(`选中素材回调事件`);
      console.log(data);
      if (data.picture_upload.length > 0) {
        this.form4 = data.picture_upload;
        this.form['4'] = this.form4;
      }
    },
    /**
     * 点击样式选中事件
    * @param {Object} item 数据
     * @date 2025-09-02
     */
    pointStyleChange(item, index) {
      this.pointStyleIndex = index;
      this.pointItem = item;
      this.saveseniorstyle.pointStyleIndex = index;
      if (!this.moreShow) return;
      this.$emit('stylechange', {
        item: this.form,
        data: this.saveseniorstyle
      });
    },
    /**
     * 跟随全局样式标识
    * @param {Object} val 数据
     * @date 2025-09-02
     */
    followGlobalChange(val) {
      this.saveseniorstyle.isFollowglobal = val;
      if (!this.moreShow) return;
      this.$emit('stylechange', {
        item: this.form,
        data: this.saveseniorstyle
      });
    }
  }
};